import { Base, createApp } from '@studiometa/js-toolkit';
import 'liquid-ajax-cart';
import Shop from './components/Shop/index.js';
import Sections from './components/Sections/index.js';
import Toast from './components/Shop/Toast/index.js';
import Animations from './components/Animations/index.js';

/**
 * App
 */
class App extends Base {
  /**
   * App Configuration
   */
  static config = {
    name: 'App',
    components: {
      Shop,
      Sections,
      Animations,
      Toast,
    },
  };

  /**
   * Toaster
   * @returns {Toast}
   */
  get Toaster() {
    if (this.$children.Toast.length <= 0) {
      throw new Error('No Toast component found');
    }

    return this.$children.Toast[0];
  }
}

export default createApp(App, {
  root: document.documentElement,
  screens: {
    '2xs': '0rem',
    xs: '30rem',
    s: '32rem',
    m: '40rem',
    l: '64rem',
    xl: '80rem',
    '2xl': '96rem',
    '3xl': '120rem',
  },
});
